/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Screen from '../Screen';
import Label from '../../Label/Label';
import Textbox from '../../Textbox/Textbox';
import Radio from '../../Radio/Radio';
import Checkbox from '../../Checkbox/Checkbox';
import Button from '../../Button/Button';
import Fab from '../../Fab/Fab';
import Dialog from '../../Dialog/Dialog';
import Entityview from '../../Entityview/Entityview';
import Entityselector from '../../Entityselector/Entityselector';
import Folderselector from '../../Folderselector/Folderselector';
import Search from '../../Search/Search';
import Service from '../../Util/Service';
import Firebase from '../../Util/Firebase';
import $ from '../../Util/Util';
import Excel from '../../Util/Excel';
import FolderOpenIcon from './opened-folder.png';
import FolderCloseIcon from './closed-folder.png';
import EntityIcon from './baseline_description_black_24dp.png';
import FolderNewIcon from './baseline_create_new_folder_black_24dp.png';
import FolderRenameIcon from './baseline_edit_black_24dp.png';
import FolderDeleteIcon from './baseline_delete_black_24dp.png';
import AddIcon from './baseline_add_white_24dp.png';
import FirstIcon from './baseline_skip_previous_black_24dp.png';
import PreviousIcon from './baseline_previous_arrow_black_24dp.png';
import NextIcon from './baseline_play_arrow_black_24dp.png';
import LastIcon from './baseline_skip_next_black_24dp.png';
import CloseIcon from './baseline_close_black_24dp.png';
import MoveIcon from './baseline_file_copy_black_24dp.png';
import ExcelIcon from './icons8-xls-48.png';
import './Dashboard.css';

/**
 * Represents the dashboard screen.
 */

export default class Dashboard extends Screen {

    /**
     * Properties.
     */

    static propTypes = {
        onEntitySelected:           PropTypes.func.isRequired
    }

    /**
     * Default state.
     */

    state = {
        selectedfolder:         null,
        selectedpath:           null,
        selectedfolderaccess:   null,
        folder:                 null,
        dashboard:              [],
        dashboardbackup:        [],
        groups:                 [],
        users:                  [],
        entitytypes:            [],
        selectedentity:         null,
        selectedentitypath:     null,
        deleteentity:           null,
        deletableentity:        null,
        newentity:              false,
        searchresult:           null,
        searchindex:            0,
        showadvancedsearch:     false,
        moveditem:              null,
        movetargetfolder:       null,
        exportpercent:          null
    }

    /**
     * Loads the dashboard and the entity types.
     * 
     * @param   {Boolean}   quick   quick loading or not
     */

    _refresh = (quick) => {

        // Creating and returning the promise object

        return new Promise((resolve, reject) => {

            // Showing the progress indicator

            this.props.onLoading(true);

            // Quick loading

            if (quick) {

                // Loading the dashboard

                Service.loadDashboard(this.props.context.user.admin ? null : this.props.context.user.group.id).then((dashboard) => {
                    
                    this.setState({ dashboard: dashboard });

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Resolving

                    resolve();
                }).catch((error) => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Showing error

                    $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });

                    // Rejecting

                    reject();
                });
            } else {

                // Loading the groups

                Service.loadGroup().then((groups) => {
                    this.setState({ groups: groups });

                    // Loading the users

                    Service.loadUser().then((users) => {
                        this.setState({ users: users });

                        // Loading the entity types

                        Service.loadEntitytype().then((entitytypes) => {
                            this.setState({ entitytypes: entitytypes });

                            // Loading the dashboard

                            Service.loadDashboard(this.props.context.user.admin ? null : this.props.context.user.group.id).then((dashboard) => {
                                this.setState({ dashboard: dashboard });

                                // Hiding the progress indicator

                                this.props.onLoading(false);

                                // Resolving

                                resolve();
                            }).catch((error) => {

                                // Hiding the progress indicator

                                this.props.onLoading(false);

                                // Showing error

                                $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });

                                // Rejecting

                                reject();
                            });
                        }).catch((error) => {

                            // Hiding the progress indicator

                            this.props.onLoading(false);

                            // Showing error

                            $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });

                            // Rejecting

                            reject();
                        });
                    }).catch((error) => {

                        // Hiding the progress indicator

                        this.props.onLoading(false);

                        // Showing error

                        $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });

                        // Rejecting

                        reject();
                    });
                }).catch((error) => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Showing error

                    $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });

                    // Rejecting

                    reject();
                });
            }
        });
    }

    _search = (criteria) => {

        // Preparing

        if (!criteria) {
            criteria = {
                entitytypes:    {},
                pattern:        true,
                tags:           true,
                caseinsesitive: true,
                filter:         true
            };

            this.state.entitytypes.forEach((item) => {
                criteria.entitytypes[item.id] = item;
            });
        }

        // Setting the group

        criteria.group = this.props.context.user.admin ? null : this.props.context.user.group.id;

        // Getting the searched value

        criteria.search = this.searchtext.getValue();

        // Showing the progress indicator

        this.props.onLoading(true);

        // Searching

        Service.search(criteria).then((result) => {

            // Storing the search result

            this.setState({ searchresult: result, searchindex: 0 }, () => {
                if (result) {

                    // Filtering
                    
                    if (criteria.filter) {
                        let filter = (item) => {
                            item.forEach((i) => {
                                if (i.entities) {
                                    let items = [];

                                    i.entities.forEach((ent) => {
                                        for (let j = 0; j < result.length; j++) {
                                            if (result[j].id === ent.id) {
                                                items.push(ent);
                                                break;
                                            }
                                        }
                                    });

                                    if (items.length > 0) {
                                        i.entities = items;
                                    } else {
                                        delete i.entities;
                                    }
                                }

                                if (i.folders) {
                                    filter(i.folders);
                                }
                            });
                        };

                        this.setState({ dashboardbackup: this.state.dashboard}, () => {
                            let dashboard = JSON.parse(JSON.stringify(this.state.dashboard));
                            filter(dashboard);
                            this.setState({ dashboard: dashboard });
                        });
                    } else {
                        this.setState({ dashboardbackup: null });
                    }

                    this._gotoEntity(this.state.searchresult[0]);
                }

                // Hiding the progress indicator

                this.props.onLoading(false);

                if (!result) {

                    // Showing unsuccessfull searching

                    $.fireEvent('snackbar', { message: this.props.context.locale.dashboard.search.noresult });
                }
            });
        }).catch((error) => {
            
            // Hiding the progress indicator

            this.props.onLoading(false);

            // Showing error

            $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
        });
    }

    _advanceSearch = () => {
        this.setState({ showadvancedsearch: true });
    }

    _closeAdvanceSearch = () => {
        this.setState({ showadvancedsearch: false });
    }

    /**
     * Event that fires when the user wants to close the search result navigator.
     */

    _closeSearch = () => {
        this.setState({ searchresult: null }, () => {
            if (this.state.dashboardbackup != null) {
                this.setState({ dashboard: this.state.dashboardbackup });
            }
        });
    }

    _showFirstSearchResult = () => {
        if (this.state.searchindex > 0) {
            this.setState({ searchindex: 0 }, () => {
                this._gotoEntity(this.state.searchresult[this.state.searchindex]);
            });
        }
    }

    _showPreviousSearchResult = () => {
        if (this.state.searchindex > 0) {
            this.setState({ searchindex: this.state.searchindex - 1 }, () => {
                this._gotoEntity(this.state.searchresult[this.state.searchindex]);
            });
        }
    }

    _showNextSearchResult = () => {
        if (this.state.searchindex < (this.state.searchresult.length - 1)) {
            this.setState({ searchindex: this.state.searchindex + 1 }, () => {
                this._gotoEntity(this.state.searchresult[this.state.searchindex]);
            });
        }
    }

    _showLastSearchResult = () => {
        if (this.state.searchindex < (this.state.searchresult.length - 1)) {
            this.setState({ searchindex: this.state.searchresult.length -1 }, () => {
                this._gotoEntity(this.state.searchresult[this.state.searchindex]);
            });
        }
    }

    _gotoEntity = (entity) => {
        let path = entity.path.split('/');

        path.forEach((item, index) => {
            if (['folders', 'entities'].indexOf(item) < 0) {
                if (index === (path.length - 1)) {
                    this._selectEntity({ id: item, path: entity.path });
                    ReactDOM.findDOMNode(this['entity_' + item]).scrollIntoView(false);
                } else {
                    ReactDOM.findDOMNode(this['folder_' + item]).style.display = '';
                    ReactDOM.findDOMNode(this['foldericon_' + item]).src = FolderOpenIcon;
                }
            }
        });
    }

    _gotoFolder = (folder) => {
        try {
            let path = folder.split('/');

            path.forEach((item) => {
                if (['folders'].indexOf(item) < 0) {
                    ReactDOM.findDOMNode(this['folder_' + item]).style.display = '';
                    ReactDOM.findDOMNode(this['foldericon_' + item]).src = FolderOpenIcon;
                }
            });
        } catch (error) {
            // No handler
        }
    }

    _toggleFolder = (folder, path, currentaccess) => {
        let fld = ReactDOM.findDOMNode(this['folder_' + folder]);
        let state = fld.style.display !== 'none';
        ReactDOM.findDOMNode(this['foldericon_' + folder]).src = state ? FolderCloseIcon : FolderOpenIcon;
        fld.style.display = (state ? 'none' : '');
        this.setState({ selectedfolder: folder, selectedfolderaccess: currentaccess, selectedpath: path });
    }

    _getFolderWidth = () => {
        return ((this.state.selectedentity || this.state.newentity) && !this.props.context.environment.browser.info.mobile) ? ((this.props.context.environment.screen.width - (4 * 16)) / 2) : (this.props.context.environment.screen.width - 34);
    }

    _selectEntity = (entity) => {
        let ent = ReactDOM.findDOMNode(this['entity_' + entity.id]);
        
        if (ent.classList.contains('dashboard-entity-selected')) {
            ent.className = 'dashboard-entity dashboard-entity-unselected';
            this.setState({ selectedentity: null});
        } else {
            if (this.state.selectedentity) {
                ReactDOM.findDOMNode(this['entity_' + this.state.selectedentity]).className = 'dashboard-entity dashboard-entity-unselected';
            }
    
            ent.className = 'dashboard-entity dashboard-entity-selected';
            this.setState({ selectedentity: entity.id, selectedentitypath: entity.path }, () => {
                if (!this.props.context.environment.browser.info.mobile) {
                    this.entityview.loadEntity(entity, entity.currentaccess === 'r');
                }
            });
        }

        if (this.props.context.environment.browser.info.mobile) {
            this.props.onEntitySelected(entity.id, entity.path, entity.currentaccess === 'r');
        }
    }

    _openNewRenameFolderDialog = (folder, event) => {
        event.stopPropagation();

        let groups = this.state.groups;
        groups.forEach((item) => {
            if ($.isObject(folder) && folder.access) {
                item.disabled = !folder.access[item.id];
            } else if ($.isObject(folder)) {
                item.disabled = true;
            } else {
                item.disabled = item.defaultaccess ? false : true;
            }
        });

        this.setState({ groups: groups}, () => {
            this.folderdialog.open().then(() => {
                if ($.isObject(folder) && folder.access) {
                    Object.keys(folder.access).forEach((key) => {
                        this['group' + key].setValue(true);

                        if (folder.access[key] === 'rw') {
                            this['group' + key + '_1'].setValue(true);
                        } else {
                            this['group' + key + '_0'].setValue(true);
                        }
                    });

                    groups.forEach((item) => {
                        if (item.disabled) {
                            this['group' + item.id + '_0'].setValue(true);
                        }
                    });
                } else if ($.isObject(folder)) {
                    groups.forEach((item) => {
                        this['group' + item.id].setValue(false);
                        this['group' + item.id + '_0'].setValue(true);
                        this['group' + item.id + '_1'].setValue(false);
                    });
                } else {
                    groups.forEach((item) => {
                        this['group' + item.id].setValue(item.defaultaccess ? true : false);
                        this['group' + item.id + '_0'].setValue(!item.defaultaccess || item.defaultaccess === 'r');
                        this['group' + item.id + '_1'].setValue(item.defaultaccess === 'rw');
                    });
                }
        
                this.setState({ folder: folder }, () => {
                    this.foldername.setValue(
                        $.isObject(folder) ? folder.name : this.props.context.locale.dashboard.createfolderdialog.newfolder
                    );
                });   
            });
        });
    }

    _closeEntityView = (id) => {
        if (id !== 'newentity') {
            let ent = ReactDOM.findDOMNode(this['entity_' + id]);
            ent.className = 'dashboard-entity dashboard-entity-unselected';
        }
        
        this.setState({ selectedentity: null, newentity: false});    
    }

    _closeNewRenameFolderDialog = () => {
        this.folderdialog.close();
    }

    _saveFolder = () => {

        // Validating

        if (this.foldername.isEmpty()) {
            
            // Showing error

            $.fireEvent(
                'snackbar', 
                { message: this.props.context.locale.dashboard.createfolderdialog.validation.missingname, error: true }
            );

            return;
        }

        // Preparing

        let foldername = this.foldername.getValue();
        let root = this.rootfolder ? this.rootfolder.getValue() : null;
        let access = {};

        // Getting the folder access

        this.state.groups.forEach((item) => {
            if (this['group' + item.id].getValue()) {
                access[item.id] = this['group' + item.id + '_0'].getValue() ? 'r' : 'rw';
            }
        });

        this.folderdialog.close().then(() => {

            // Showing the progress indicator

            this.props.onLoading(true);

            if ($.isObject(this.state.folder)) {

                // Renaming the folder

                Service.renameFolder(this.state.folder.path, foldername, access).then(() => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Loading the dashboard and the entity types

                    this._refresh(true);                    
                }).catch((error) => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Showing error

                    $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });                    
                });
            } else {

                // Creating the folder

                Service.createFolder(this.state.folder, foldername, root, access).then(() => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Loading the dashboard and the entity types

                    this._refresh(true);                    
                }).catch((error) => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Showing error

                    $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });                    
                });
            }
        });
    }

    _openMoveDialog = (item, event) => {

        // Preparing

        event.stopPropagation();

        // Close entity view
        
        if (item.entitytype) {
            this._closeEntityView(item.id);
        }

        // Opening the dialog

        this.setState({ moveditem: item, movetargetfolder: null }, () => {
            this.moveFolderEntityDialog.open().then(() => {

                // Showing progress indicator
    
                this.props.onLoading(true);
    
                // Refreshing the folder tree
    
                this.folderselector.load().then(() => {
    
                    // Hiding progress indicator
    
                    this.props.onLoading(false);                  
                });
            });    
        });
    }

    _closeMoveFolderEntityDialog = () => {
        this.moveFolderEntityDialog.close();
    }

    _onMoveFolderSelected = (folder) => {
        this.setState({ movetargetfolder: folder });
    }

    _moveItem = () => {
        if (this.state.movetargetfolder === null) {
            $.fireEvent('snackbar', { message: this.props.context.locale.dashboard.movefolderentitydialog.nofolderselected });
        } else {
            let path = {};

            if (this.state.moveditem.entitytype) {
                let pos = this.state.moveditem.path.indexOf('/entities/');
                path.source = this.state.moveditem.path.substring(0, pos);
                path.target = this.state.movetargetfolder.path;
            } else {
                path.source = this.state.moveditem.path;
                path.target = this.state.movetargetfolder.path;
            }

            if (!this.state.moveditem.entitytype && (path.source === path.target || path.source === (path.target + '/folders/' +this.state.moveditem.id))) {
                $.fireEvent('snackbar', { message: this.props.context.locale.dashboard.movefolderentitydialog.invalidfolder });
            } else {

                this._closeMoveFolderEntityDialog();

                // Showing progress indicator
    
                this.props.onLoading(true);

                // Moving

                if (this.state.moveditem.entitytype) {
                    Service.moveEntity(this.state.moveditem.id, this.state.moveditem.name, this.state.moveditem.path, path.target).then(() => {

                        // Hiding progress indicator
    
                        this.props.onLoading(false);

                        // Refreshing

                        this._refresh(true);
                    }).catch((error) => {

                        // Hiding the progress indicator

                        this.props.onLoading(false);

                        // Showing error

                        $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });                    
                    });
                } else {
                    Service.moveFolder(path.source, path.target, this.state.dashboard).then(() => {

                        // Hiding progress indicator
    
                        this.props.onLoading(false);

                        // Refreshing
                        
                        this._refresh(true);
                    }).catch((error) => {

                        // Hiding the progress indicator

                        this.props.onLoading(false);

                        // Showing error

                        $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });                    
                    });
                }
            }
        }
    }

    _openDeleteEntityDialog = (entity) => {
        let versions = Object.keys(entity.versions);

        // Sorting the versions

        versions.sort((a, b) => {
            return parseInt(a.substring(1), 10) - parseInt(b.substring(1), 10);
        });

        let attributes = entity.versions[versions[versions.length - 1]].attributes;

        for (let i = 0; i < attributes.length; i++) {
            if (attributes[i].primary) {
                this.setState({ deleteentity: attributes[i].value, deletableentity: entity }, () => {
                    this.deleteEntityConfirmDialog.open();
                });
                break;
            }
        }
    }

    _openDeleteFolderDialog = (folder, event) => {
        event.stopPropagation();
        
        if (this.state.dashboard && this.state.dashboard.length > 1) {
            this.setState({ folder: folder }, () => {
                this.deleteFolderConfirmDialog.open();
            });
        }
    }

    _closeDeleteFolderDialog = () => {
        this.deleteFolderConfirmDialog.close();
    }

    _deleteFolder = () => {
        this.deleteFolderConfirmDialog.close().then(() => {

            // Showing the progress indicator

            this.props.onLoading(true);

            // Creating the folder

            Service.deleteFolder(this.state.folder.path).then(() => {

                // Hiding the progress indicator

                this.props.onLoading(false);

                // Loading the dashboard and the entity types

                this._refresh(true);
            }).catch((error) => {

                // Hiding the progress indicator

                this.props.onLoading(false);

                // Showing error

                $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });                    
            });
        });
    }

    _closeDeleteEntityDialog = () => {
        return this.deleteEntityConfirmDialog.close();
    }

    _deleteEntity = () => {
        this._closeDeleteEntityDialog().then(() => {

            // Showing the progress indicator

            this.props.onLoading(true);

            // Deleting uploaded files of the entity

            let file = [];

            Object.keys(this.state.deletableentity.versions).forEach((key) => {
                this.state.deletableentity.versions[key].attributes.forEach((item) => {
                    if (item.type === 'file') {
                        if (item.multivalue) {
                            item.value.forEach((i, ind) => {
                                if (i.url && file.indexOf(i.url) < 0) {
                                    file.push(i.url);
                                }    
                            });
                        } else {
                            if (item.value.url && file.indexOf(item.value.url) < 0) {
                                file.push(item.value.url);
                            }
                        }
                    } else if (item.type === 'picture' && item.value && file.indexOf(item.value) < 0) {
                        file.push(item.value);
                    }
                });
            });

            let deleteFile = (index, callback) => {
                if (index >= file.length) {
                    callback();
                } else {
                    Firebase.deleteFile(file[index]).then(() => {
                        deleteFile(index + 1, callback);
                    }).catch((error) => {
                        
                        // Showing error

                        $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });                        

                        // Callbacking

                        callback();
                    });
                }
            };

            deleteFile(0, () => {
                Service.deleteEntity(this.state.selectedentity, this.state.selectedentitypath).then(() => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Closing the entity view

                    this._closeEntityView(this.state.selectedentity);
                    
                    let dashboard = this.state.dashboard;
                    let paths = this.state.selectedentitypath.split('/');
        
                    let search = (index, item) => {
                        for (let i = 0; i < item.length; i++) {
                            if (item[i].id === paths[index]) {
                                if (index === paths.length - 1) {
                                    item.splice(i, 1);
                                } else {
                                    search(index + 2, paths[index + 1] === 'entities' ? item[i].entities : item[i].folders);
                                }
        
                                break;
                            }
                        }
                    };
        
                    search(0, dashboard);
        
                    this.setState({ dashboard: dashboard });
                }).catch((error) => {

                    // Hiding the progress indicator

                    this.props.onLoading(false);

                    // Showing error

                    $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });
                });
            });
        });
    }

    _createEntity = () => {
        this.setState({ newentity : true }, () => {
            if (this.props.context.environment.browser.info.mobile) {
                this.props.onEntitySelected('newentity', this.state.selectedpath, false);
            } else {
                this.entityview.newEntity(this.state.selectedpath);
            }
        });
    }

    _toggleRootfolder = () => {
        this.rootfolder.toggle();
    }

    /**
     * Adds a new relation.
     */

    _addNewRelation = () => {
        this.addRelationDialog.open().then(() => {
            this.entityselector.load();
        });
    }

    /**
     * Closes the add new relation dialog.
     */

    _closeAddNewRelationDialog = () => {
        this.addRelationDialog.close();
    }

    /**
     * Event that fires when an entity selected at the add new relation dialog.
     */

    _onEntitySelected = () => {
        let relation = this.entityselector.getSelectedEntity();

        if (relation) {
            this.entityview.addRelation(relation);
        }
        
        this._closeAddNewRelationDialog();
    }

    _goToRelation = (relation) => {
        let path = relation.path.split('/');

        path.forEach((item, index) => {
            if (['folders', 'entities'].indexOf(item) < 0) {
                if (index === (path.length - 1)) {
                    this._selectEntity({ id: item, path: relation.path });

                    if (!this.props.context.environment.browser.info.mobile) {
                        ReactDOM.findDOMNode(this['entity_' + item]).scrollIntoView(false);
                    }
                } else {
                    ReactDOM.findDOMNode(this['folder_' + item]).style.display = '';
                    ReactDOM.findDOMNode(this['foldericon_' + item]).src = FolderOpenIcon;
                }
            }
        });
    }

    _onPrimaryValueChanged = (path, value, id, entitytype) => {
        if (id) {
            let dashboard = this.state.dashboard;
            let paths = path.split('/');
            let fullpath = `${path}/entities/${id}`.split('/');

            let search = (index, item) => {
                for (let i = 0; i < item.length; i++) {
                    if (item[i].id === paths[index]) {
                        if (index === paths.length - 1) {
                            item[i].entities = item[i].entities ? item[i].entities : [];
                            item[i].entities.push({
                                id:         id,
                                path:       `${path}/entities/${id}`,
                                name:       value,
                                namedpath:  item[i].namedpath.substring(0, item[i].namedpath.lastIndexOf('/') + 1) + value,
                                entitytype: entitytype
                            });
                        } else {
                            search(index + 2, item[i].folders);
                        }

                        break;
                    }
                }
            };

            search(0, dashboard);

            this.setState({ dashboard: dashboard }, () => {
                if (this.state.selectedentity) {
                    ReactDOM.findDOMNode(this['entity_' + this.state.selectedentity]).className = 'dashboard-entity dashboard-entity-unselected';
                }
        
                let ent = ReactDOM.findDOMNode(this['entity_' + id]);
                ent.className = 'dashboard-entity dashboard-entity-selected';
                this.setState({ selectedentity: id, selectedentitypath: `${path}/entities/${id}` });

                fullpath.forEach((item, index) => {
                    if (['folders', 'entities'].indexOf(item) < 0) {
                        if (index === (fullpath.length - 1)) {
                            ReactDOM.findDOMNode(this['entity_' + item]).scrollIntoView(false);
                        } else {
                            ReactDOM.findDOMNode(this['folder_' + item]).style.display = '';
                            ReactDOM.findDOMNode(this['foldericon_' + item]).src = FolderOpenIcon;
                        }
                    }
                });
            });
        } else {
            let dashboard = this.state.dashboard;
            let paths = path.split('/');

            let search = (index, item) => {
                for (let i = 0; i < item.length; i++) {
                    if (item[i].id === paths[index]) {
                        if (index === paths.length - 1) {
                            item[i].name = value;
                            item[i].namedpath = item[i].namedpath.substring(0, item[i].namedpath.lastIndexOf('/') + 1) + value;
                        } else {
                            search(index + 2, paths[index + 1] === 'entities' ? item[i].entities : item[i].folders);
                        }

                        break;
                    }
                }
            };

            search(0, dashboard);

            this.setState({ dashboard: dashboard });

            paths.forEach((item, index) => {
                if (['folders', 'entities'].indexOf(item) < 0) {
                    if (index === (paths.length - 1)) {
                        ReactDOM.findDOMNode(this['entity_' + item]).scrollIntoView(false);
                    } else {
                        ReactDOM.findDOMNode(this['folder_' + item]).style.display = '';
                        ReactDOM.findDOMNode(this['foldericon_' + item]).src = FolderOpenIcon;
                    }
                }
            });
        }
    }

    _groupCheckedChange = (value, index) => {
        let groups = this.state.groups;
        groups[index].disabled = !value;
        this.setState({ groups: groups });
    }

    _toggleGroupCheckbox = (checkbox) => {
        this[checkbox].toggle();
    }

    /**
     * Exports the all of the entities from the screen to MS-Excel.
     */

    _exportToExcel = () => {

        // Showing the progress indicator

        this.props.onLoading(true);

        this.setState({ exportpercent: 0 }, () => {
            let entities = [];
            let header = [ { name: this.props.context.locale.dashboard.export.entitytype, attr: 'entitytype', type: Excel.COLUMN.STRING } ];
            let multiEntityType = false;
            let lastEntityType = null;

            let exportEntity = (entity) => {
                if (lastEntityType === null) {
                    lastEntityType = entity.entitytype;
                } else {
                    if (lastEntityType !== entity.entitytype) {
                        multiEntityType = true;
                    }
                }

                let ent = this.state.entitytypes.find((et) => { return entity.entitytype === et.id; });

                ent.attributes.forEach((attr) => {
                    if (['integer', 'float', 'text', 'multilinetext', 'date', 'radio', 'checkbox', 'user', 'externallink'].indexOf(attr.type) >= 0) {
                        if (!header.find((h) => { return h.attr === attr.id; })) {
                            let attrType;

                            if (['integer', 'float'].indexOf(attr.type) >= 0) {
                                attrType = Excel.COLUMN.NUMBER;
                            } else if (['date'].indexOf(attr.type) >= 0) {
                                attrType = Excel.COLUMN.DATE;
                            } else {
                                attrType = Excel.COLUMN.STRING;
                            }

                            header.push({ name: attr.name, attr: attr.id, type: attrType, ordernr: attr.ordernr });
                        }
                    }
                });

                let row = { entitytype: ent.name };

                let versions = [];

                Object.keys(entity.versions).forEach((version) => {
                    versions.push(version.substring(1));
                });

                versions.sort((a, b) => {
                    return parseInt(a, 10) - parseInt(b, 10);
                });

                let version = versions[versions.length - 1];

                ent.attributes.forEach((attr) => {
                    let value = entity.versions['v' + version].attributes[attr.id];
                    if (value && ['integer', 'float', 'text', 'multilinetext', 'date', 'radio', 'checkbox', 'user', 'externallink'].indexOf(attr.type) >= 0) {
                        if (attr.type === 'date') {
                            if (attr.multivalue) {
                                value.forEach((v, index) => {
                                    value[index] = new Date(value[index]);
                                });
                            } else {
                                value = new Date(value);
                            }
                        } else if (attr.type === 'user') {
                            let user = this.state.users.find((u) => { return u.uid === value; });

                            if (user) {
                                value = user.name + ' [' + user.email + ']';
                            }
                        }

                        if (attr.multivalue) {
                            row[attr.id] = value.join();
                        } else {
                            row[attr.id] = value;
                        }
                    }
                });

                entities.push(row);
            };

            let getFolder = (folder) => {
                if (folder.entities) {
                    folder.entities.forEach((entity) => {
                        exportEntity(entity);
                    });
                }

                if (folder.folders) {
                    folder.folders.forEach((fld) => {
                        getFolder(fld);
                    });
                }
            };

            this.state.dashboard.forEach((fld) => {
                getFolder(fld);
            });

            if (multiEntityType) {
                header.sort((a, b) => {
                    if (a.name === this.props.context.locale.dashboard.export.entitytype) {
                        return -1;
                    } else {
                        let nameA = a.name.toUpperCase();
                        let nameB = b.name.toUpperCase();

                        if (nameA < nameB) {
                            return -1;
                        } else if (nameA > nameB) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                });
            } else {
                header.sort((a, b) => {
                    if (a.name === this.props.context.locale.dashboard.export.entitytype) {
                        return -1;
                    } else {
                        if (a.ordernr < b.ordernr) {
                            return -1;
                        } else if (a.ordernr > b.ordernr) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                });
            }

            this.setState({ exportpercent: 50 }, () => {
                setTimeout(() => {
        
                    // Export to Excel

                    Excel.create({ sheet: 'miniCRS export', header: header, worker: false }, entities);

                    this.setState({ exportpercent: 100 }, () => {

                        // Hiding the progress indicator
            
                        setTimeout(() => {
                            this.setState({ exportpercent: null }, () => {
                                this.props.onLoading(false);
                            });
                        }, 1000);
                    });
                }, 200);
            });
        });
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(this.props.context.locale.dashboard.title);

        // Loading the dashboard and the entity types

        this._refresh().then(() => {

            // Go to the home directory of the user

            if (!window.firstlogin && this.props.context.user.homedirectory) {
                window.firstlogin = true;
                this._gotoFolder(this.props.context.user.homedirectory);
            }
        });
    }

    /** 
     * Dashboard screen renderer.
     */

    render() {
        let renderFolder = (folder, level) => {
            return (
                folder.map((item) => {
                    return (
                        <div key={item.id} style={{ position: 'relative', left: (level === 1 ? 0 : 32) + 'px', width: `calc(100% - ${level === 1 ? 0 : 32}px)` }}>
                            { !item.entitytype &&
                                <div className={`dashboard-folder ${(this.state.selectedfolder === item.id) ? 'dashboard-folder-select' : 'dashboard-folder-unselect'}`} style={{ width: (this._getFolderWidth() - 16 - ((level - 1) * 32)) + 'px' }} onClick={this._toggleFolder.bind(this, item.id, item.path, item.currentaccess)}>
                                    <div className="horizontal center">
                                        <img ref={c => {this['foldericon_' + item.id] = c;}} alt="Folder" src={FolderCloseIcon} className="dashboard-folder-icon" />
                                        <div className="dashboard-folder-label">{item.name}</div>
                                        <div className="flex"></div>
                                        { this.state.selectedfolder === item.id && !this.state.selectedentity && !this.state.newentity && this.state.selectedfolderaccess === 'rw' && <img alt="New folder" src={FolderNewIcon} className="dashboard-folder-toolbar-icon" title={this.props.context.locale.dashboard.folder.create} onClick={this._openNewRenameFolderDialog.bind(this, item.path)} /> }
                                        { this.state.selectedfolder === item.id && !this.state.selectedentity && !this.state.newentity && this.state.selectedfolderaccess === 'rw' && <div><img alt="Rename folder" src={FolderRenameIcon} className="dashboard-folder-toolbar-icon" title={this.props.context.locale.dashboard.folder.modify} onClick={this._openNewRenameFolderDialog.bind(this, item)} /></div> }
                                        { this.state.selectedfolder === item.id && !this.state.selectedentity && !this.state.newentity && this.state.selectedfolderaccess === 'rw' && <div><img alt="Move folder" src={MoveIcon} className="dashboard-folder-toolbar-icon" title={this.props.context.locale.dashboard.folder.move} onClick={this._openMoveDialog.bind(this, item)} /></div> }
                                        { this.state.selectedfolder === item.id && !this.state.selectedentity && !this.state.newentity && this.state.selectedfolderaccess === 'rw' && <div><img alt="Delete folder" src={FolderDeleteIcon} className="dashboard-folder-toolbar-icon" title={this.props.context.locale.dashboard.folder.remove} style={{marginRight: '16px', opacity: (!item.folders || item.folders.length === 0) ? 1 : 0.4}} onClick={this._openDeleteFolderDialog.bind(this, item)} /></div> }
                                    </div>
                                </div>
                            }

                            { item.entitytype &&
                                <div ref={c => {this['entity_' + item.id] = c;}} className="dashboard-entity dashboard-entity-unselected" style={{ width: (this._getFolderWidth() - 16 - ((level - 1) * 32)) + 'px' }} onClick={this._selectEntity.bind(this, item)}>
                                    <div className="horizontal center">
                                        <img alt="Entity" src={EntityIcon} className="dashboard-entity-icon" />
                                        <div className="dashboard-entity-label">{item.name}</div>
                                        <div className="flex"></div>
                                        { this.state.selectedentity === item.id && <div style={{ marginRight: 16 }}><img alt="Move entity" src={MoveIcon} className="dashboard-folder-toolbar-icon" title={this.props.context.locale.dashboard.entitymove} onClick={this._openMoveDialog.bind(this, item)} /></div> }
                                    </div>
                                </div>
                            }

                            { !item.entitytype &&
                                <div ref={c => {this['folder_' + item.id] = c;}} style={{ display: 'none' }}>
                                    { item.folders && renderFolder(item.folders, level + 1)}
                                    { item.entities && renderFolder(item.entities, level + 1)}
                                </div>
                            }
                        </div>
                    );                    
                })
            );
        };

        return (
            <div className="dashboard">

                {/* Searchbox */}

                <div className="horizontal">
                    <Textbox ref={c => {this.searchtext = c;}} disabled={this.state.searchresult !== null} width={this.props.context.environment.screen.width - (this.state.searchresult ? 339 : 160)} tooltip={this.props.context.locale.dashboard.search.tooltip} placeholder={this.props.context.locale.dashboard.search.placeholder} onEnter={this._search} />
                    { this.state.searchresult && <div className="horizontal">
                        <img alt="First icon" src={FirstIcon} className="dashboard-search-icon" title={this.props.context.locale.dashboard.search.navigation.first} style={{ marginLeft: '8px', opacity: this.state.searchindex === 0 ? 0.2 : 1 }} onClick={this._showFirstSearchResult} />
                        <img alt="Previous icon" src={PreviousIcon} className="dashboard-search-icon" title={this.props.context.locale.dashboard.search.navigation.previous} style={{ opacity: this.state.searchindex === 0 ? 0.2 : 1 }} onClick={this._showPreviousSearchResult} />
                        <div className="dashboard-search-count">{`${this.state.searchindex + 1} / ${this.state.searchresult.length}`}</div>
                        <img alt="Next icon" src={NextIcon} className="dashboard-search-icon" title={this.props.context.locale.dashboard.search.navigation.next} style={{ opacity: this.state.searchindex < (this.state.searchresult.length - 1) ? 1 : 0.2 }} onClick={this._showNextSearchResult} />
                        <img alt="Last icon" src={LastIcon} className="dashboard-search-icon" title={this.props.context.locale.dashboard.search.navigation.last} style={{ opacity: this.state.searchindex < (this.state.searchresult.length - 1) ? 1 : 0.2 }} onClick={this._showLastSearchResult} />
                        <img alt="Close icon" src={CloseIcon} className="dashboard-search-close-icon" title={this.props.context.locale.dashboard.search.close} style={{ marginRight: '8px' }} onClick={this._closeSearch} />
                    </div> }
                    <Button label={this.props.context.locale.dashboard.search.button.label} disabled={this.state.searchresult !== null} tooltip={this.props.context.locale.dashboard.search.button.tooltip} mini leftgap={2} onTouch={this._advanceSearch} />
                    <div>{ this.state.exportpercent === null ? <img src={ExcelIcon} alt="Export to MS-Excel" className="dashboard-excel-icon" title={this.props.context.locale.dashboard.exporttoexcel} onClick={this._exportToExcel}></img> : <div className="dashboard-export-percent">{this.state.exportpercent + '%'}</div>}</div>
                </div>

                {/* Advanced search */}

                { this.state.showadvancedsearch && <Search context={this.props.context} entitytypes={this.state.entitytypes} users={this.state.users} onClose={this._closeAdvanceSearch} onSearch={this._search} /> }

                <div className="horizontal">

                    {/* Folders and entities */}

                    <div className="dashboard-folder-container vertical" style={{ width: this._getFolderWidth() + 'px', height: (this.props.context.environment.screen.usefullheight - 84) + 'px' }}>
                        { renderFolder(this.state.dashboard, 1) }

                        { this.state.selectedfolder && this.state.selectedfolderaccess === 'rw' && !this.state.selectedentity && !this.state.newentity && <div className="dashboard-add-icon">
                            <Fab icon={AddIcon} tooltip={this.props.context.locale.dashboard.newentitytooltip} onTouch={this._createEntity} />
                        </div>}
                    </div>

                    {/* Spacer */}

                    <div className="dashboard-folder-spacer"></div>

                    {/* Entity */}

                    { !this.props.context.environment.browser.info.mobile &&
                        <div className="dashboard-entity-view-container" style={{ display: (this.state.selectedentity || this.state.newentity) ? '' : 'none', width: ((this.state.selectedentity || this.state.newentity) ? ((this.props.context.environment.screen.width - (4 * 16)) / 2) : 0) + 'px' }}>
                            <div className="dashboard-entity-view">
                                { (this.state.selectedentity || this.state.newentity) && <Entityview ref={c => {this.entityview = c;}} context={this.props.context} users={this.state.users} entitytypes={this.state.entitytypes} id={this.state.selectedentity || 'newentity' } onLoading={this.props.onLoading} onClose={this._closeEntityView} onDelete={this._openDeleteEntityDialog} onNewRelation={this._addNewRelation} onGotoRelation={this._goToRelation} onPrimaryValueChanged={this._onPrimaryValueChanged} /> }
                            </div>
                        </div>
                    }
                </div>

                {/* Create/Rename folder dialog */}

                <Dialog ref={c => {this.folderdialog = c;}} width={340} height={250 + ($.isObject(this.state.folder) ? 0 : 48)} closetooltip={this.props.context.locale.dashboard.createfolderdialog.close}>
                    <div className="dashboard-folderdialog-title">{$.isObject(this.state.folder) ? this.props.context.locale.dashboard.createfolderdialog.title.rename : this.props.context.locale.dashboard.createfolderdialog.title.create}</div>
                    <Textbox ref={c => {this.foldername = c;}} label={this.props.context.locale.dashboard.createfolderdialog.field.name.label} tooltip={this.props.context.locale.dashboard.createfolderdialog.field.name.tooltip} placeholder={this.props.context.locale.dashboard.createfolderdialog.field.name.placeholder} labelwidth={60} width={252} maxlength={40} isrequired />
                    { !$.isObject(this.state.folder) && <div className="horizontal">
                        <Checkbox ref={c => {this.rootfolder = c;}} leftgap={60} />
                        <Label text={this.props.context.locale.dashboard.createfolderdialog.field.root.label} tooltip={this.props.context.locale.dashboard.createfolderdialog.field.root.tooltip} leftgap={8} onTouch={this._toggleRootfolder} />
                    </div>}
                    
                    {/* Group access */}

                    <div className="dashboard-folderdialog-access-container horizontal">
                        <div><Label text={this.props.context.locale.dashboard.createfolderdialog.field.rights.label} width={60} /></div>
                        <div className="dashboard-folderdialog-access">
                            { this.state.groups.map((item, index) =>
                                <div key={index} className="dashboard-folderdialog-access-group horizontal center">
                                    <Checkbox ref={c => {this['group' + item.id] = c;}} index={index} rightgap={4} onChecked={this._groupCheckedChange} />
                                    <div className={`dashboard-folderdialog-access-groupname ${item.disabled ? 'dashboard-folderdialog-access-groupname-disabled' : 'dashboard-folderdialog-access-groupname-enabled'}`} onClick={this._toggleGroupCheckbox.bind(this, 'group' + item.id)}>{item.name}</div>
                                    <div className="flex"></div>
                                    <Radio ref={c => {this['group' + item.id + '_0'] = c;}} label={this.props.context.locale.dashboard.createfolderdialog.field.rights.read.label} tooltip={this.props.context.locale.dashboard.createfolderdialog.field.rights.read.tooltip} disabled={item.disabled} holder={this} group={'group' + item.id + '_'} index={0} topgap={2} bottomgap={2} rightgap={8} />
                                    <Radio ref={c => {this['group' + item.id + '_1'] = c;}} label={this.props.context.locale.dashboard.createfolderdialog.field.rights.readwrite.label} tooltip={this.props.context.locale.dashboard.createfolderdialog.field.rights.readwrite.tooltip} disabled={item.disabled} holder={this} group={'group' + item.id + '_'} index={1} topgap={2} bottomgap={2} />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Buttons */}

                    <div className="dashboard-folderdialog-buttons horizontal">
                        <div className="flex"></div>
                        <Button label={this.props.context.locale.dashboard.createfolderdialog.buttons.cancel.label} tooltip={this.props.context.locale.dashboard.createfolderdialog.buttons.cancel.tooltip} width={80} onTouch={this._closeNewRenameFolderDialog} />
                        <Button label={this.props.context.locale.dashboard.createfolderdialog.buttons.save.label} tooltip={this.props.context.locale.dashboard.createfolderdialog.buttons.save.tooltip} leftgap={8} width={80} onTouch={this._saveFolder} />
                    </div>
                </Dialog>

                {/* Delete folder confirm dialog */}

                <Dialog ref={c => {this.deleteFolderConfirmDialog = c;}} width={340} height={132} closetooltip={this.props.context.locale.dashboard.deletefolderdialog.close}>
                    <div className="dashboard-folderdialog-title">{this.props.context.locale.dashboard.deletefolderdialog.message}</div>
                    <div className="dashboard-folderdialog-name">{this.state.folder ? this.state.folder.name : ''}</div>

                    <div className="horizontal" style={{ marginTop: '28px' }}>
                        <div className="flex"></div>
                        <Button label={this.props.context.locale.dashboard.deletefolderdialog.buttons.cancel.label} tooltip={this.props.context.locale.dashboard.deletefolderdialog.buttons.cancel.tooltip} width={80} onTouch={this._closeDeleteFolderDialog} />
                        <Button label={this.props.context.locale.dashboard.deletefolderdialog.buttons.yes.label} tooltip={this.props.context.locale.dashboard.deletefolderdialog.buttons.yes.tooltip} leftgap={8} width={80} onTouch={this._deleteFolder} />
                    </div>
                </Dialog>

                {/* Add relation dialog */}

                <Dialog ref={c => {this.addRelationDialog = c;}} width={320} height={268} closetooltip={this.props.context.locale.dashboard.addrelationdialog.close}>
                    <div className="dashboard-entitydialog-title">{this.props.context.locale.dashboard.addrelationdialog.message}</div>
                    <Entityselector ref={c => {this.entityselector = c;}} context={this.props.context} height={160} onLoading={this.props.onLoading} />
                    <div className="horizontal">
                        <div className="flex"></div>
                        <Button label={this.props.context.locale.dashboard.addrelationdialog.buttons.cancel.label} tooltip={this.props.context.locale.dashboard.addrelationdialog.buttons.cancel.tooltip} width={60} topgap={10} onTouch={this._closeAddNewRelationDialog} />
                        <Button label={this.props.context.locale.dashboard.addrelationdialog.buttons.ok.label} tooltip={this.props.context.locale.dashboard.addrelationdialog.buttons.ok.tooltip} width={60} topgap={10} leftgap={8} onTouch={this._onEntitySelected} />
                    </div>
                </Dialog>

                {/* Delete entity confirm dialog */}

                <Dialog ref={c => {this.deleteEntityConfirmDialog = c;}} width={320} height={132} closetooltip={this.props.context.locale.dashboard.deleteentitydialog.close}>
                    <div className="dashboard-entitydialog-title">{this.props.context.locale.dashboard.deleteentitydialog.message}</div>
                    <div className="dashboard-entitydialog-name">{this.state.deleteentity}</div>

                    <div className="horizontal" style={{ marginTop: '28px' }}>
                        <div className="flex"></div>
                        <Button label={this.props.context.locale.dashboard.deleteentitydialog.buttons.cancel.label} tooltip={this.props.context.locale.dashboard.deleteentitydialog.buttons.cancel.tooltip} width={60} onTouch={this._closeDeleteEntityDialog} />
                        <Button label={this.props.context.locale.dashboard.deleteentitydialog.buttons.yes.label} tooltip={this.props.context.locale.dashboard.deleteentitydialog.buttons.yes.tooltip} width={60} leftgap={8} onTouch={this._deleteEntity} />
                    </div>
                </Dialog>

                {/* Move folder/entity dialog */}

                <Dialog ref={c => {this.moveFolderEntityDialog = c;}} width={320} height={316} closetooltip={this.props.context.locale.dashboard.movefolderentitydialog.close}>
                    <div className="dashboard-entitydialog-title">{this.props.context.locale.dashboard.movefolderentitydialog.title}</div>
                    { this.state.moveditem && <div className="dashboard-entitydialog-name" style={{ marginBottom: 16}}>{`${this.state.moveditem.name} ${this.state.moveditem.entitytype ? this.props.context.locale.dashboard.movefolderentitydialog.messageentity : this.props.context.locale.dashboard.movefolderentitydialog.messagefolder}`}</div> }
                    <Folderselector ref={c => {this.folderselector = c;}} context={this.props.context} onSelect={this._onMoveFolderSelected} onLoading={this.props.onLoading} />
                    <div className="horizontal" style={{ marginTop: '16px' }}>
                        <div className="flex"></div>
                        <Button label={this.props.context.locale.dashboard.movefolderentitydialog.buttons.cancel.label} tooltip={this.props.context.locale.dashboard.movefolderentitydialog.buttons.cancel.tooltip} width={60} onTouch={this._closeMoveFolderEntityDialog} />
                        <Button label={this.props.context.locale.dashboard.movefolderentitydialog.buttons.ok.label} tooltip={this.props.context.locale.dashboard.movefolderentitydialog.buttons.ok.tooltip} width={60} leftgap={8} onTouch={this._moveItem} />
                    </div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Dashboard/Dashboard.js